import styled from "styled-components/native";

const Row = styled.View`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default Row;



// WEBPACK FOOTER //
// ./src/components/Row/Row.js